export default __webpack_public_path__ + "static/media/help.052fcad1.svg";